var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"stat",staticClass:"work-stat"},[_c('div',{staticClass:"legend"},[_vm._v(_vm._s(_vm.legend))]),_c('div',{ref:"number",staticClass:"number",attrs:{"data-amount":_vm.number}},[_vm._v(_vm._s(_vm.numberObj.amount))])])}
var staticRenderFns = []

export { render, staticRenderFns }